import { Typography, Box, Theme, SxProps, Tooltip } from '@mui/material';

export type ProfileCardProps = Readonly<{
  title: string;
  subtitle?: string;
  iconSrc?: string;
  supportingText?: string;
}>;

export const ProfileCard = ({ title, subtitle, iconSrc, supportingText }: ProfileCardProps) => {
  return (
    <Box sx={containerSx}>
      <Box className="content" sx={cardContentSx}>
        <Box sx={headingSx} className="heading_and_icon">
          {iconSrc && <Box component="img" src={iconSrc} sx={iconSx} />}

          <Box sx={textSx} className="text">
            <Tooltip title={title} placement="top">
              <Typography variant="text-md-semibold" sx={titleSx}>
                {title}
              </Typography>
            </Tooltip>

            <Typography
              variant="text-sm-regular"
              color={(theme: Theme) => theme.backrs.colors['Gray/600']}
            >
              {/* adding the u00A0 to get an empty character so the line still takes space and the style is consistent across cards */}
              {subtitle || '\u00A0'}
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="text-sm-regular"
          color={(theme: Theme) => theme.backrs.colors['Gray/600']}
        >
          {/* adding the u00A0 to get an empty character so the line still takes space and the style is consistent across cards */}
          {supportingText || '\u00A0'}
        </Typography>
      </Box>
    </Box>
  );
};

const textSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const headingSx: SxProps<Theme> = ({ backrs }) => ({
  gap: backrs.spacing['spacing-lg'],
  display: 'flex',
});

const cardContentSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: backrs.spacing['spacing-2xl'],
  gap: backrs.spacing['spacing-3xl'],
});

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  cursor: 'pointer',
  display: 'flex',
  minWidth: {
    xs: '80%',
    sm: '320px',
  },
  flexDirection: 'column',
  alignItems: 'flex-start',
  flex: '1 0 0',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Beige/950']}`,
  boxShadow: backrs.shadows['shadow-xs'],

  maxWidth: '24rem',
});

const iconSx: SxProps<Theme> = {
  width: '3rem',
  height: '3rem',
  borderRadius: '50%',
};

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Gray/900'],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
});
